import styled from '@emotion/styled'

export const ReviewEntriesColumnHeaderWrapper = styled.span`
  display: block;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;

  > * {
    display: block;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
  }
`
